import { ServiceSchema } from "@redotech/redo-fulfillment-carrier-common/carrier-service-catalog";
import { CarrierSchema } from "@redotech/redo-fulfillment-carrier-common/carriers-and-services";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { ParcelSchema } from "./parcel";

// Using reserved scan shortcuts is fine, but the user
// Should be informed that presets will always trump
export enum Hotkey {
  CMD_0 = "⌘0",
  CMD_1 = "⌘1",
  CMD_2 = "⌘2",
  CMD_3 = "⌘3",
  CMD_4 = "⌘4",
  CMD_5 = "⌘5",
  CMD_6 = "⌘6",
  CMD_7 = "⌘7",
  CMD_8 = "⌘8",
  CMD_9 = "⌘9",
  A = "⌘A",
  B = "⌘B",
  // C = "⌘c", copy, preventable but people will think its a bug
  D = "⌘D",
  E = "⌘E",
  F = "⌘F",
  G = "⌘G",
  H = "⌘H",
  I = "⌘I", // focus input
  J = "⌘J", // personalized insert
  K = "⌘K",
  // L = "⌘L", focus address bar, unpreventable
  M = "⌘M",
  // N = "⌘N", new window, unpreventable
  O = "⌘O",
  // P = "⌘p", print label
  // Q = "⌘Q", quit, unpreventable
  // R = "⌘r", reload page, unpreventable
  S = "⌘S", // print packing slip
  // T = "⌘T", new tab, unpreventable
  U = "⌘U",
  // V = "⌘v", paste, preventable but people will think its a bug
  // W = "⌘W", close tab, unpreventable
  X = "⌘X",
  Y = "⌘Y",
  Z = "⌘Z",
}

export const reservedScanKeys: Hotkey[] = [Hotkey.I, Hotkey.J, Hotkey.S];

export const getHotkeyDisplayName = (hotkey: Hotkey) => {
  const isMac = navigator.platform.toLowerCase().includes("mac");
  if (!isMac) {
    return hotkey.replace("⌘", "Ctrl ");
  }
  return hotkey.replace("⌘", "⌘ ");
};

export const HotkeySchema = createEnum(Hotkey, { enumName: "Hotkey" });

export const PresetSchema = z.object({
  _id: zExt.objectId(),
  name: z.string(),
  hotkey: HotkeySchema,
  carrier: CarrierSchema.nullish(),
  service: ServiceSchema.nullish(),
  parcel: ParcelSchema.nullish(),
  totalWeightInOunces: z.number().nullish(),
});
export type Preset = z.infer<typeof PresetSchema>;

/**
 * Document-level schema representing how presets are stored in MongoDB.
 * The preset data is nested under the `preset` field.
 */
export const PresetDocumentSchema = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  preset: PresetSchema,
  createdAt: z.date(),
  updatedAt: z.date(),
});
export type PresetDocument = z.infer<typeof PresetDocumentSchema>;
